import React, { useContext, createContext, useState } from "react";

const BannerCarouselContext = createContext();

export const BannerCarouselContextProvider = ({ children }) => {
  const state = useState({
    height: 270,
    width: 390,
    defaults: true,
    bannerContainerHeight: 200,
    cta: false,
  });
  return (
    <BannerCarouselContext.Provider value={state}>
      {children}
    </BannerCarouselContext.Provider>
  );
};

const useBannerCarouselContext = () => useContext(BannerCarouselContext);

export default useBannerCarouselContext;
